import { useState, useEffect } from 'react';

export default () => {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const scrollDiv = document.createElement('div');
    scrollDiv.style.width = '100px';
    scrollDiv.style.height = '100px';
    scrollDiv.style.overflow = 'scroll';
    scrollDiv.style.position = 'absolute';

    document.body.appendChild(scrollDiv);
    const scrollBarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);

    setWidth(scrollBarWidth);
  }, []);

  return width;
};
